module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"setCloudAccountCurrenciesCard.title":"Set Currency Source","setCloudAccountCurrenciesCard.subtitle":"Change the currency source of this cloud connection.","setCloudAccountCurrenciesCard.alert":"Changes to the currency source of a cloud connection only apply to the current month on."}}')
  delete Component.options._Ctor
}
